import { styled } from '@mui/material';
import Logo from '../../components/Logo';
import { GivelifyButton, GivelifyLabel, GivelifyLink } from '@givelify/ui';

export const Wrapper = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    maxWidth: 800,
    margin: '0 auto',
    [theme.breakpoints.down('mobile')]: {
        paddingTop: 24,
    },
    padding: '48px 16px',
}));

export const GivelifyLogo = styled(Logo)(({ theme }) => ({
    width: '100%',
    [theme.breakpoints.down('mobile')]: {
        marginBottom: 16,
    },
    marginBottom: 48,
}));

export const Title = styled(GivelifyLabel)(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        marginBottom: 16,
    },
    marginBottom: 32,
}));

export const List = styled('ul')(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        marginBottom: 16,
    },
    marginBottom: 32,
    marginTop: 0,
}));

export const Footer = styled(GivelifyLabel)(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        marginBottom: 24,
    },
    marginBottom: 32,
}));

export const SubmitButton = styled(GivelifyButton)(() => ({
    justifySelf: 'end',
}));

export const Link = styled(GivelifyLink)(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        fontSize: '14px',
    },
    fontSize: '20px',
}));
